<div class="card step-card flex flex-column">
  <div>
    <form *ngIf="deviceMeasurementsForm" [formGroup]="deviceMeasurementsForm">

      <div class="flex flex-column sm:flex-row justify-content-end">
        <div class="flex h-full cursor-pointer" [ngStyle]="{'min-height': '2rem'}"
             (click)="fileInput.click()">
            <div class="w-full">
                <input hidden type="file" accept=".csv" #fileInput (change)="uploadFile($event.target.files)">
                    <button
                      [label]="'common.importSensors' | transloco"
                      pButton
                      pRipple
                      icon="pi pi-upload"
                      iconPos="left">
                    </button>
            </div>
        </div>

        <button
          [label]="'new.sensor' | transloco"
          (click)="addMeasurement()"
          pButton
          pRipple
          class="sm:ml-2 mt-2 sm:mt-0"
          icon="pi pi-plus"
          iconPos="left"
        ></button>
        <button
          [label]="'misc.copyFromDevice' | transloco"
          (click)="displayCopyFromDevice = true"
          pButton
          pRipple
          class="sm:ml-2 mt-2 sm:mt-0"
          icon="pi pi-copy"
          iconPos="left"
        ></button>
      </div>
      <div *ngIf="rowsForm.controls.length > 0" class="my-5" formArrayName="deviceMeasurements">
        <p-table
          *ngIf="rowsForm"
          [value]="rowsForm.controls"
          [(first)]="first"
          [(rows)]="rows"
          [rowsPerPageOptions]="[10,25,50]"
          [totalRecords]="totalMeasures"
          [paginator]="true"
          [responsive]="true"
          breakpoint="1800px"
          styleClass="p-datatable-striped"
          [tableStyle]="{ width: 'max-content'}"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>{{'attribute.name' | transloco}} (*)</th>
              <th>{{'attribute.description' | transloco}}</th>
              <th>{{'attribute.alias' | transloco}}</th>
              <th>{{'model.sensorType' | transloco}} (*)</th>
              <th class="w-6rem">{{'attribute.sampleRate' | transloco}}</th>
              <th class="w-4rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-control let-rowIndex="rowIndex">
            <tr [formGroupName]="rowIndex" class="fadein">
              <td>
                <span class="p-column-title">{{'attribute.name' | transloco}} (*)</span>
                <input pInputText type="text" formControlName="name">
              </td>
              <td>
                <span class="p-column-title">{{'attribute.description' | transloco}}</span>
                <input pInputText type="text" formControlName="description">
              </td>
              <td>
                <span class="p-column-title">{{'attribute.alias' | transloco}}</span>
                <input pInputText type="text" formControlName="alias">
              </td>
              <td>
                <span class="p-column-title">{{'model.sensorType' | transloco}} (*)</span>
                <p-dropdown
                  [placeholder]="'select.type' | transloco"
                  [options]="getMeasurementTypes(rowIndex)"
                  [disabled]="isDefault(rowIndex)"
                  styleClass="dropdown-width-md"
                  formControlName="measurementType"
                  optionLabel="sensor"
                ></p-dropdown>
              </td>
              <td class="w-6rem">
                <span class="p-column-title">{{'attribute.sampleRate' | transloco}}</span>
                <input pInputText type="number" formControlName="sampleRate" class="w-6rem">
              </td>
              <td class="text-center">
                <span class="p-column-title">{{'common.delete' | transloco}}</span>
                <button
                  (click)="onRowDelete(rowIndex)"
                  pButton
                  pRipple
                  class="p-button-rounded p-button-text p-button-danger"
                  type="button"
                  icon="pi pi-trash"
                ></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalMeasures == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalMeasures > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalMeasures ? totalMeasures : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalMeasures}}
              {{(totalMeasures > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
      <div *ngIf="rowsForm.controls.length === 0" class="font-italic text-center mt-7">
        {{'empty.measurements' | transloco}}
      </div>
    </form>
  </div>
  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.previous' | transloco"
          (click)="onPreviousStep()"
          pButton
          pRipple
          class="flex-1 sm:flex-none"
          icon="pi pi-angle-left"
          iconPos="left"
        ></button>
        <button
          [label]="'common.next' | transloco"
          (click)="onNextStep()"
          [disabled]="!deviceMeasurementsForm?.valid"
          pButton
          pRipple
          class="ml-2 flex-1 sm:flex-none"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="onCancel()"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>
</div>
<app-device-selector
  [(visible)]="displayCopyFromDevice"
  [tenant]="tenant"
  [actionButtons]="copyFromDeviceActions"
></app-device-selector>
